/* VU Customizer — Sentry error tracking.
   Loaded as a blocking script from vu_customizer_snippet.liquid, AFTER the
   Sentry CDN bundles and BEFORE the inline customizer script that injects the
   VU engine (main.js from S3). Keep it blocking: the engine's fetches can only
   be instrumented if Sentry.init runs first.
   ES5 only — theme assets have no build step. Must be safe to run twice and
   safe when the Sentry CDN is blocked by ad blockers. */
(function () {
  'use strict';

  if (window.VuSentry) return;

  // No-op shim so theme callers (handleError, vu_main.js) never break when
  // the Sentry SDK failed to load.
  if (!window.Sentry || typeof window.Sentry.init !== 'function') {
    window.VuSentry = { enabled: false, capture: function () {} };
    return;
  }

  var DSN = 'https://3c82a90063606a7df7177ee2a7624f1f@o4507419639021568.ingest.us.sentry.io/4511781528010752'; // public DSN — vu-customizer project (peak-achievement-athletics)

  if (DSN.indexOf('http') !== 0) {
    window.VuSentry = { enabled: false, capture: function () {} };
    return;
  }

  var cfg = window.vuSentryConfig || {};

  var VU_URL_RE = /(vu-customizer\.s3\.amazonaws\.com|vu-admin\.s3\.amazonaws\.com|s3\.amazonaws\.com\/vu-os|vucustom\.com|vu_main\.js|vu_sentry\.js|vu_customizer_restore_selections\.js)/;
  var CART_ADD_RE = /\/cart\/add(\.js)?(\?|$)/;

  function customizerValues() {
    // customizer_values is declared with `let` in the snippet, so it is NOT a
    // window property — reachable only as a bare identifier.
    try { return typeof customizer_values !== 'undefined' ? customizer_values : {}; }
    catch (e) { return {}; }
  }

  function shopDomain() {
    return cfg.shop || (window.Shopify && window.Shopify.shop) || '';
  }

  function customizerEl() {
    return document.getElementById('customizer');
  }

  function attr(name) {
    var el = customizerEl();
    return (el && el.getAttribute(name)) || '';
  }

  function regionFallback() {
    var s = shopDomain() + ' ' + (window.location.hostname || '');
    if (/bauer-ca|bauer-hockey-ca|(^|\s|\.)ca\./.test(s)) return 'ca';
    if (/bauer-se|bauer-hockey-se|(^|\s|\.)se\./.test(s)) return 'se';
    if (/bauer-fi|(^|\s|\.)fi\./.test(s)) return 'fi';
    if (/bauer-dk|(^|\s|\.)dk\./.test(s)) return 'dk';
    return 'us';
  }

  function getRegion() {
    return customizerValues().country || regionFallback();
  }

  function getProduct() {
    return customizerValues().product || attr('data-variant') || cfg.variant || 'unknown';
  }

  // Shopify exposes the currently-rendered theme's role: 'main' is the published
  // live theme; anything else ('unpublished' / 'development' / 'demo') is a
  // preview/draft theme. Returns '' if unavailable.
  function themeRole() {
    try { return (window.Shopify && Shopify.theme && Shopify.theme.role) || ''; }
    catch (e) { return ''; }
  }

  function themeId() {
    try { return (window.Shopify && Shopify.theme && Shopify.theme.id) || ''; }
    catch (e) { return ''; }
  }

  function themeName() {
    try { return (window.Shopify && Shopify.theme && Shopify.theme.name) || ''; }
    catch (e) { return ''; }
  }

  // Sentry environment reflects whether these are REAL LIVE sessions or test
  // sessions — not which VU bundle was configured. Three buckets:
  //   'staging'          — any *-dev.myshopify.com store (dev testing)
  //   'production-draft' — live store, but an unpublished/preview theme is
  //                        rendering (dress-rehearsal on the real store)
  //   'production'       — live store AND the published 'main' theme (real
  //                        shoppers; the only bucket the prod alerts fire on)
  // Publishing a draft theme (role -> 'main') is what flips 'production-draft'
  // to 'production'. If the theme role can't be read on a live store, we fall
  // back to 'production' (fail toward alerting, so real incidents are never
  // silently hidden under a draft label).
  function environment() {
    if (/-dev\./.test(shopDomain())) return 'staging';
    var role = themeRole();
    if (role && role !== 'main') return 'production-draft';
    return 'production';
  }

  // Which VU bundle actually loaded (staging|production|qa|development), from
  // settings.vu_customizer_environment. Recorded as its own tag so you can tell
  // a dev store running the production engine apart from one running staging.
  function vuEngine() {
    return cfg.environment || attr('data-environment') || 'unknown';
  }

  function mainSourceUrl() {
    return cfg.main_source_url || '';
  }

  function isVuUrl(url) {
    return !!url && VU_URL_RE.test(String(url));
  }

  function stackTouchesVu(event) {
    try {
      var values = (event.exception && event.exception.values) || [];
      for (var i = 0; i < values.length; i++) {
        var frames = (values[i].stacktrace && values[i].stacktrace.frames) || [];
        for (var j = 0; j < frames.length; j++) {
          if (isVuUrl(frames[j].filename || frames[j].abs_path)) return true;
        }
      }
    } catch (e) {}
    return false;
  }

  Sentry.init({
    dsn: DSN,
    environment: environment(),
    sampleRate: 1.0,
    maxBreadcrumbs: 50,
    autoSessionTracking: false,
    integrations: [
      Sentry.httpClientIntegration({
        failedRequestStatusCodes: [[400, 599]],
        failedRequestTargets: [
          /vu-customizer\.s3\.amazonaws\.com/,
          /vu-admin\.s3\.amazonaws\.com/,
          /s3\.amazonaws\.com\/vu-os/,
          /vucustom\.com/,
          /\/api\/recipes\/.*\/images/,
          /\/cart\/add(\.js)?/
        ]
      })
    ],
    ignoreErrors: [
      /ResizeObserver loop/i,
      /Non-Error promise rejection captured/i,
      'Script error.',
      /globalThis is not defined/i,
      /instantSearchSDKJSBridgeClearHighlight/i,
      /window\.webkit\.messageHandlers/i
    ],
    denyUrls: [
      /googletagmanager\.com/,
      /google-analytics\.com/,
      /doubleclick\.net/,
      /static\.klaviyo\.com/,
      /klaviyo\.com/,
      /connect\.facebook\.net/,
      /snap\.licdn\.com/,
      /bat\.bing\.com/,
      /^chrome-extension:\/\//,
      /^moz-extension:\/\//,
      /^safari(-web)?-extension:\/\//
    ],
    beforeSend: function (event) {
      event.tags = event.tags || {};

      event.tags.region = event.tags.region || getRegion();
      event.tags.product = event.tags.product || getProduct();
      event.tags.data_variant = event.tags.data_variant || attr('data-variant') || cfg.variant || '';
      event.tags.locale = event.tags.locale || attr('data-locale') || cfg.locale || '';
      event.tags.shop = event.tags.shop || shopDomain();
      event.tags.variant_id = event.tags.variant_id || attr('data-variant-id') || cfg.variantId || '';
      event.tags.vu_engine = event.tags.vu_engine || vuEngine();
      event.tags.main_source_url = event.tags.main_source_url || mainSourceUrl();
      event.tags.theme_role = event.tags.theme_role || themeRole() || 'unknown';
      event.tags.theme_id = event.tags.theme_id || String(themeId() || '');
      event.tags.theme_name = event.tags.theme_name || themeName();

      // httpClientIntegration events carry the failed request URL — classify
      // them so alert rules can key off vu_error_type.
      var isHttpClient = false;
      var failedUrl = '';
      try {
        var v0 = event.exception && event.exception.values && event.exception.values[0];
        if (v0 && /^HTTP Client Error/.test(v0.value || '')) {
          isHttpClient = true;
          failedUrl = (event.request && event.request.url) || (v0.value.split(' ').pop() || '');
        }
      } catch (e) {}
      if (!event.tags.vu_error_type && isHttpClient) {
        event.tags.vu_error_type = CART_ADD_RE.test(failedUrl) ? 'add_to_cart' : 'asset_load';
        // Sub-tag thumbnails (kept under asset_load so the existing 403/CORS
        // alert rule still fires for them; a separate vu_error_type would
        // silently escape it).
        if (/\/api\/recipes\/.*\/images/.test(failedUrl)) {
          event.tags.vu_asset_kind = 'thumbnail';
        }
      }

      var vuRelated = !!event.tags.vu_error_type || isVuUrl(failedUrl) || stackTouchesVu(event);
      event.tags.vu_related = vuRelated ? 'true' : 'false';

      return event;
    }
  });

  window.VuSentry = {
    enabled: true,
    capture: function (message, tags, extra) {
      try {
        Sentry.withScope(function (scope) {
          var k;
          if (tags) { for (k in tags) { if (tags.hasOwnProperty(k)) scope.setTag(k, tags[k]); } }
          if (extra) { for (k in extra) { if (extra.hasOwnProperty(k)) scope.setExtra(k, extra[k]); } }
          scope.setLevel('error');
          if (tags && tags.vu_error_type) {
            scope.setFingerprint(['vu', tags.vu_error_type, message]);
          }
          Sentry.captureMessage(message);
        });
      } catch (e) {}
    }
  };

  // Resource load failures (script/link/img on VU hosts). These fire a capture-
  // phase 'error' event on the element, never reach window.onerror, and are not
  // fetches — httpClientIntegration cannot see them.
  window.addEventListener('error', function (e) {
    var t = e.target || e.srcElement;
    if (!t || !t.tagName) return; // plain JS error — Sentry's global handler owns it
    var tag = t.tagName.toLowerCase();
    if (tag !== 'script' && tag !== 'link' && tag !== 'img') return;
    var url = t.src || t.href || '';
    if (!isVuUrl(url)) return;
    window.VuSentry.capture('VU asset failed to load: <' + tag + '>', {
      vu_error_type: 'asset_load'
    }, { asset_url: url });
  }, true);

  // Add-to-cart failures. The VU add-to-cart lib dispatches this event whenever
  // POST /cart/add.js fails or variant mapping breaks. Independent of the
  // per-click listener in vu_main.js, which only handles the toast UI.
  document.addEventListener('customizer.add-to-cart-fail', function (e) {
    var detail = '';
    try { detail = JSON.stringify(e.detail).slice(0, 2000); }
    catch (err) { detail = String(e.detail); }
    window.VuSentry.capture('VU add to cart failed', {
      vu_error_type: 'add_to_cart'
    }, { detail: detail });
  });

  // CORS / network-layer failures on VU endpoints. A fetch blocked by CORS
  // (or DNS/offline) rejects with a bare TypeError carrying no URL and no
  // status — httpClientIntegration never sees it, and if the engine catches
  // the rejection itself, Sentry's global handlers don't either. Wrapping
  // fetch is the only reliable hook: here we still know the URL, so VU-bound
  // failures are captured before the rejection is handed back to the caller.
  // Non-VU URLs pass through untouched. (Unhandled rejections in general are
  // already captured by the SDK's built-in global handlers — do not add a
  // manual unhandledrejection listener; it double-reports every event.)
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = '';
      try { url = (input && input.url) || String(input || ''); } catch (e) {}
      var result = origFetch.apply(this || window, arguments);
      if (isVuUrl(url) || CART_ADD_RE.test(url)) {
        result = result.catch(function (err) {
          window.VuSentry.capture(
            'VU request failed (CORS/network): ' + url.split('?')[0],
            {
              vu_error_type: CART_ADD_RE.test(url) ? 'add_to_cart' : 'asset_load',
              vu_network_failure: 'true'
            },
            { url: url, error: String(err) }
          );
          throw err;
        });
      }
      return result;
    };
  }
})();
